module.exports = __webpack_public_path__ + "img/workshop-inactive.5de65061.png";